import { setEnvVars } from "@inst_proserv/toolkit";
import getMetaTagData from "./getMetaTagData";

const metaTagData = getMetaTagData();

const appInitialState = {
  // meta tag data from index.html
  ...metaTagData,
  // application flags
  isAppLoading: true,
  isCallingApi: false,
  isAuthenticated: false,
  isInfoModalOpen: false,
  errors: [],
  showProgressAlert: false,
  progressAlert: {
    variant: null,
    message: null,
  },
  isCreatedCourseModalOpen: false,
  createdCourse: {
    curriculum: "",
    startDate: "",
    endDate: "",
    language: "",
    deliveryModality: "",
    title: "",
    message: "",
    error: false,
  },
};

export type AppState = typeof appInitialState & { [key: string]: any };

setEnvVars(metaTagData);

export default appInitialState;
